import {
  AnswerContent,
  TextContent,
  SpaceContent,
  SpaceType,
} from '@/resource/question/question.type';

const answerExample = new AnswerContent(
  [new SpaceContent(SpaceType.Empty, 100, 200)],
  [new TextContent('This is an answer for this question')],
);

export default answerExample;
